import { createClientErrorId } from "../../../../../../shared/frontend/feedback/clientErrorIds";
import { postClientErrorOnce } from "../errors/clientErrorReporter";
import { classifyApiError,shouldLogApiErrorToBackend } from "./apiErrorPolicy";
import type { ApiError } from "./client";

const MAX_RESPONSE_BODY_LENGTH = 800;
const MAX_API_MESSAGE_LENGTH = 500;
/** Cloudflare-spezifischer Statuscode: Origin-Server hat nicht rechtzeitig geantwortet. */
const HTTP_STATUS_CLOUDFLARE_TIMEOUT = 524;

function describeResponseBody(e: ApiError, isSystemFailure: boolean): string | null {
  const rawBody = (e.bodyText ?? "").trim();
  if (!rawBody) return null;
  if (isSystemFailure) return `[server error, ${rawBody.length} chars]`;
  if (/^\s*</.test(rawBody) || /<html/i.test(rawBody)) return `[HTML response${e.status === HTTP_STATUS_CLOUDFLARE_TIMEOUT ? ", timeout (524)" : ""}, ${rawBody.length} chars]`;
  return rawBody.slice(0, MAX_RESPONSE_BODY_LENGTH);
}

/**
 * Meldet einen API-Fehler ans Backend (client-errors), damit er im System-Log landet. Welche Fehler
 * gemeldet werden, entscheidet `apiErrorPolicy`; Kennungen ermittelt der Server aus der Anmeldung.
 */
export function logApiErrorToBackend(e: ApiError): void {
  if (!shouldLogApiErrorToBackend(e)) return;
  try {
    const classification = classifyApiError(e);
    const isSystemFailure = classification.class === "SystemFailure";
    const endpoint = e.url ?? "unknown";
    postClientErrorOnce({
      errorId: createClientErrorId("API"),
      message: `${endpoint} failed (${e.status}${classification.errorKey ? ` ${classification.errorKey}` : ""})`,
      source: "api.request",
      sourceKind: "ApiError",
      context: {
        endpoint,
        status: String(e.status),
        code: classification.errorKey ?? null,
        requestId: e.requestId != null ? String(e.requestId) : null,
        class: classification.class,
        reason: classification.reason,
        apiMessage: isSystemFailure ? "server error; details in server log" : (e.message ?? "").slice(0, MAX_API_MESSAGE_LENGTH),
        responseBody: describeResponseBody(e, isSystemFailure),
      },
    });
  } catch {
    // Fehler-Logging darf nie weitere sichtbare Fehler auslösen.
  }
}
